var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"1400","max-height":"1200","hide-overlay":"","fullscreen":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{attrs:{"color":"#ECEFF1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }